import axios from 'axios'

export default {
    namespaced: true,
    state: {
        sms: [],
        emails: [],
    },
    mutations: {
        SET_SMS(state, sms) {
            state.sms = sms;
        },
        SET_EMAILS(state, emails) {
            state.emails = emails;
        },
        ADD_SMS(state, sms) {
            state.sms.push(sms);
        },
        ADD_EMAIL(state, email) {
            state.emails.push(email);
        },
        DELETE_SMS(state, sms_id) {
            state.sms = state.sms.filter(s => s.id !== sms_id);
        },
        DELETE_EMAIL(state, email_id) {
            state.emails = state.emails.filter(e => e.id !== email_id);
        }
    },
    getters: {
        sms: state => state.sms,
        emails: state => state.emails,
    },
    actions: {
        loadSms({ commit }, user_id) {
            axios.get(`/templates/sms/${user_id}`)
            .then(sms => {
                commit('SET_SMS', sms.data);
            })
            .catch(e => {
                console.log(e);
            });
        },
        loadEmails({ commit }, user_id) {
            axios.get(`/templates/emails/${user_id}`)
            .then(emails => {
                commit('SET_EMAILS', emails.data);
            })
            .catch(e => {
                console.log(e);
            });
        },  
    }
}